import * as React from "react";
import { ActivityWithBrand } from "../../../../../../../../server/models/activity";
import { Job } from "../../../../../../../../server/models/job";
import { Sample } from "../../../../../../../../server/models/graph/outline";
import { OutlinePanel, OutlinePanelTitle } from "../../../outline";
import { SamplePanel } from "./sample-panel";
import { TargetPanel } from "./target-panel";

export type TestPanelProps = {
	activity: ActivityWithBrand;
	job: Job;
	samples: Sample[];
	benchmarkName?: string;
	onViewQuotaPage: () => void;
};
export const TestPanel = React.memo((props: TestPanelProps) => {
	const { activity, job, samples, onViewQuotaPage, benchmarkName } = props;
	return (
		<OutlinePanel className={"panel"}>
			<OutlinePanelTitle>テスト概要</OutlinePanelTitle>
			<TargetPanel
				activity={activity}
				hasStrategyGroup={job.hasStrategicTarget}
				isDemandForecastNeeded={job.isDemandForecastNeeded}
			/>
			<SamplePanel samples={samples} onViewQuotaPage={onViewQuotaPage} job={job} benchmarkName={benchmarkName} />
		</OutlinePanel>
	);
});
